import adminRoutes from "./AdminRoutes/index";
import landingPageRoutes from "./ExternalRoutes/landingPageRoutes";
import authRoutes from "./ExternalRoutes/authRoutes";
import previewRoutes from "./AdminRoutes/ProtectedRoutes/previewRoutes";
import presentationRoutes from "./AdminRoutes/ProtectedRoutes/presentationRoutes";
import usersRoutes from "./ExternalRoutes/usersRoutes";
import projectorRoutes from "./AdminRoutes/ProtectedRoutes/projectorRoutes";
import { settingsRoutes } from "./AdminRoutes/ProtectedRoutes/settingsRoutes";
import { listRoutes } from "./AdminRoutes/ProtectedRoutes/listRoutes";
import GlobalErrorElement from "../components/ErrorBoundary/CustomErrorPage";
import { playlistRoutes } from "./AdminRoutes/ProtectedRoutes/playlistRoutes";
import { postPresentationRoutes } from "./AdminRoutes/ProtectedRoutes/postPresentationRoutes";
import { newEventRoute } from "./AdminRoutes/ProtectedRoutes/newEventRoutes";
import { dashboardRoutes } from "./AdminRoutes/ProtectedRoutes/dashboardRoutes";
import { studioRoutes } from "./AdminRoutes/ProtectedRoutes/studioRoutes";
import ticketsRoute from "./AdminRoutes/ProtectedRoutes/ticketsRoute";
import { devRoutes } from "./devRoutes";
import { pagesRoute } from "./AdminRoutes/ProtectedRoutes/pageRoutes";
import { createBrowserRouter } from "react-router-dom";
import { engagementRoutes } from "./AdminRoutes/ProtectedRoutes/engagementRoutes";
import { emailRoutes } from "./AdminRoutes/ProtectedRoutes/emailRoutes";

export const router = createBrowserRouter([
  {
    path: "/",
    lazy: async () => {
      const mod = await import("../components/RootLayout")
      return { Component: mod.RootLayout };
    } ,
    errorElement: <GlobalErrorElement />, // Add the global error element here
    children: [
      {
        path: "/auth/sso-callback",
        lazy: async () => {
          const mod = await import("./SsoCallback");
          return { Component: mod.default };
        },
      },
      {
        path: "/auth/logout",
        lazy: async () => {
          const mod = await import("./CrossDomainLogout");
          return { Component: mod.default };
        },
      },
      ...landingPageRoutes,
      ...authRoutes,
      ...adminRoutes,
      ...previewRoutes,
      ...presentationRoutes,
      ...usersRoutes,
      ...projectorRoutes,
      ...settingsRoutes,
      ...pagesRoute,
      ...listRoutes,
      ...playlistRoutes,
      ...postPresentationRoutes,
      ...newEventRoute,
      ...dashboardRoutes,
      ...studioRoutes,
      ...ticketsRoute,
      ...devRoutes, 
      ...engagementRoutes,
      ...emailRoutes
    ],
  },
  {
    path: "*",
    lazy: async () => {
      const mod = await import("views/ErrorPage/NotFound");
      return { Component: mod.default };
    },
  },
]);
